export default __webpack_public_path__ + "static/media/visa-master.e4f9499b.png";